import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { ArrowLeft, LogOut, KeyRound, ShieldCheck } from "lucide-react";

export default function AppShell({ children, title, subtitle, showBack = true }) {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isDashboard = location.pathname === "/panel";

  return (
    <div className="min-h-screen bg-[var(--mep-black)] mep-grain text-white">
      {/* Top bar */}
      <header className="sticky top-0 z-40 bg-[rgba(10,10,10,0.85)] backdrop-blur-md border-b border-[var(--mep-border)]">
        <div className="max-w-6xl mx-auto px-5 py-4 flex items-center justify-between">
          {!isDashboard && showBack ? (
            <button
              data-testid="back-btn"
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 text-sm text-[var(--mep-text-muted)] hover:text-white transition"
            >
              <ArrowLeft size={16} /> Atrás
            </button>
          ) : (
            <Link to="/panel" data-testid="logo-link" className="flex items-center gap-2">
              <span className="font-accent text-2xl text-[var(--mep-gold)]">M</span>
              <span className="font-display font-light tracking-tight">Mi Entrenador Personal</span>
            </Link>
          )}
          <div className="flex items-center gap-4 md:gap-5">
            {user?.is_admin && (
              <Link
                to="/admin"
                data-testid="admin-link"
                className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[var(--mep-gold)] hover:text-white transition"
                title="Panel administrativo"
              >
                <ShieldCheck size={14} /> <span className="hidden md:inline">Admin</span>
              </Link>
            )}
            <Link
              to="/cambiar-contrasena"
              data-testid="change-password-link"
              className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[var(--mep-text-muted)] hover:text-[var(--mep-gold)] transition"
              title="Cambiar contraseña"
            >
              <KeyRound size={14} /> <span className="hidden md:inline">Contraseña</span>
            </Link>
            <button
              data-testid="logout-btn"
              onClick={() => { logout(); navigate("/"); }}
              className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[var(--mep-text-muted)] hover:text-[var(--mep-pink)] transition"
            >
              <LogOut size={14} /> Salir
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-5 py-8 md:py-12">
        {title && (
          <div className="mb-8 md:mb-12">
            <div className="mep-pill-gold mb-4">Mi Entrenador Personal</div>
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tighter">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-3 text-[var(--mep-text-muted)] text-base md:text-lg max-w-2xl">{subtitle}</p>
            )}
          </div>
        )}
        {children}
      </main>

      <footer className="border-t border-[var(--mep-border)] mt-16">
        <div className="max-w-6xl mx-auto px-5 py-8 text-center">
          <p className="text-xs text-[var(--mep-text-muted)] tracking-[0.18em] uppercase">
            Esta información es educativa y no sustituye la consulta médica.
          </p>
        </div>
      </footer>
    </div>
  );
}
